<template>
  <Breadcrumb />
  <div
    class="accordion mb-3 mt-2"
    :id="String.format('Accordion_{0}', gridSettings.action)"
    ref="accordion"
  >
    <div class="accordion-item">
      <h2
        class="accordion-header"
        :id="String.format('Accordion_{0}_head', gridSettings.action)"
      >
        <button
          class="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="
            String.format('#Accordion_{0}_tab1', gridSettings.action)
          "
          aria-expanded="true"
          :aria-controls="
            String.format('Accordion_{0}_tab1', gridSettings.action)
          "
        >
          <p class="text-capitalize fs-5 mb-0">
            {{
              $t(
                "PermissionGroups.PageFilter",
                {},
                { locale: this.$store.state.activeLang }
              )
            }}
          </p>
        </button>
      </h2>
      <div
        :id="String.format('Accordion_{0}_tab1', gridSettings.action)"
        class="accordion-collapse collapse show"
        :aria-labelledby="
          String.format('Accordion_{0}_head', gridSettings.action)
        "
        :data-bs-parent="String.format('Accordion_{0}', gridSettings.action)"
      >
        <div class="accordion-body">
          <div class="row mt-2 align-items-center">
            <div class="col-md-2">
              {{
                $t(
                  "Projects.ActivePassive",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}
            </div>
            <div class="col-md-10">
              <FormSelect
                id="ActivePassive"
                type="SelectWithLocalData"
                :resetSelect="selectsReset"
                :selectedData="selectedActivePassive"
                :allowEmpty="false"
                :data="activePassiveData"
                @onChange="onChangeActivePassive"
              />
            </div>
          </div>
          <div class="col-md-12 mt-2 text-end">
            <button
              type="button"
              class="btn btn-success btn-history-filter-search me-2"
              @click="onSearch('btn-history-filter-search')"
            >
              <span>
                {{
                  $t(
                    "Projects.Search",
                    {},
                    { locale: this.$store.state.activeLang }
                  )
                }}
              </span>
            </button>
            <button
              type="button"
              class="btn btn-history-filter-clear btn-danger"
              @click="onClear"
            >
              {{
                $t(
                  "Projects.Clear",
                  {},
                  { locale: this.$store.state.activeLang }
                )
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="d-flex justify-content-end"
    v-if="this.$store.getters._isSuperAdmin"
  >
    <router-link to="New" class="btn btn-success btn-action-new-page"
      ><i class="bi bi-plus"></i>
      {{
        $t("Projects.NewButton", {}, { locale: this.$store.state.activeLang })
      }}</router-link
    >
  </div>
  <Grid
    :settings="gridSettings"
    :columns="gridColumns"
    :rows="projects"
    @onCompanyClearCacheButtonClick="onCompanyClearCacheButtonClick"
    @onCompanyResetCacheButtonClick="onCompanyResetCacheButtonClick"
    @onRequestFinally="onSearchEnd"
  />
  <AreYouSureModal
    :modalType="areYouSureModalType"
    :warningMessage="areYouSureModalWarningMessage"
    :requestParameter="areYouSureModalRequestParameter"
    :data="projectData"
    :isBrsAxios="true"
  />
</template>
<script>
import AreYouSureModal from "@/components/layout/AreYouSureModal.vue";
import $ from "jquery";
export default {
  name: "ProjectList",
  components: {
    AreYouSureModal,
  },
  data() {
    return {
      projects: [],
      selectsReset: false,
      activePassiveData: [
        {
          key: 1,
          value: this.$t(
            "BaseModelFields.Active",
            {},
            { locale: this.$store.state.activeLang }
          ),
        },
        {
          key: 2,
          value: this.$t(
            "BaseModelFields.Passive",
            {},
            { locale: this.$store.state.activeLang }
          ),
        },
      ],
      selectedActivePassive: [
        {
          key: 1,
          value: this.$t(
            "BaseModelFields.Active",
            {},
            { locale: this.$store.state.activeLang }
          ),
        },
      ],
      areYouSureModalType: "",
      areYouSureModalRequestParameter: "",
      areYouSureModalWarningMessage: "",
      projectData: {
        CompanyId: "",
        ProcessType: "",
      },
      isCompanyCache: false,
      gridSettings: {
        action: "ProjectList",
        requestUrl: String.format(""),
        requestUrlRouteParamNames: [],
        routeRequiredParameters: [
          {
            key: "projectId",
            value: "publicId",
            isRouteParameter: false,
          },
        ],

        serialNoLink: `#/Project/Detail/`,

        httpRequestType: "POST",
        allowSearchPanel: true,
        allowExcelExport: true,
        allowDragAndDrop: false,
        allowPaging: true,
        allowDeleting: false,
        allowReset: true,
        autoOrderProcess: true,
        isGatewayRequest: true,
        areYouSureModalType: "",
        areYouSureModalRequestParameter: "",
        areYouSureModalWarningMessage: "",
        buttons: [
          // {
          //   name: "detail",
          //   cssClass: "btn-primary",
          //   iconClass: "bi-arrow-up-right-square",
          //   routeButton: true,
          //   routeObj: {
          //     name: "ProjectDetail",
          //     params: {
          //       projectId: "",
          //     },
          //   },
          // },
          {
            name: "edit",
            cssClass: "btn-warning",
            iconClass: "bi-pencil-square",
            routeButton: true,
            routeObj: {
              name: "ProjectEdit",
              params: {
                projectId: "",
              },
            },
          },
          {
            name: "reset",
            cssClass: "btn-outline-info",
            iconClass: "bi bi-recycle",
            routeButton: false,
            emitMethodName: "onCompanyResetCacheButtonClick",
            attributes: {
              "data-bs-toggle": "modal",
              "data-bs-target": "#modalAreYouSure",
            },
            iconAttributes: {
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              title: this.$t(
                "Components.AreYouSureModal.ResetCompanyCacheTitle",
                {},
                { locale: this.$store.state.activeLang }
              ),
            },
          },
          {
            name: "clear",
            cssClass: "btn-outline-danger",
            iconClass: "bi bi-x-circle-fill",
            routeButton: false,
            emitMethodName: "onCompanyClearCacheButtonClick",
            attributes: {
              "data-bs-toggle": "modal",
              "data-bs-target": "#modalAreYouSure",
            },
            iconAttributes: {
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              title: this.$t(
                "Components.AreYouSureModal.ClearCompanyCacheTitle",
                {},
                { locale: this.$store.state.activeLang }
              ),
            },
          },
        ],
      },
      gridColumns: [
        {
          text: this.$t(
            "Projects.CompanyId",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "companyId",
          type: "string",
          visible: true,
          width: 100,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "Projects.Name",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "name",
          type: "string",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "Projects.CompanyName",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "appName",
          type: "string",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "Projects.CompanyAdminEmail",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "contactPersonEmail",
          type: "string",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "Projects.RelatedPerson",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "contactPerson",
          type: "string",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "Projects.UserCount",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "startUserCount",
          type: "string",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "Projects.ActiveUserCount",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "currentUserCount",
          type: "string",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "Projects.DateOfContract",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "contractStartDate",
          type: "string",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
      ],
      submitButtonHtml: String.format(
        '<span class="loading-block"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span> {0}</span></span>',
        this.$t(
          "Buttons.PleaseWait",
          {},
          { locale: this.$store.state.activeLang }
        )
      ),
      disabledButtonClasses:
        ".btn-history-filter-search, .btn-history-filter-clear",
    };
  },
  methods: {
    onCompanyResetCacheButtonClick(rowData) {
      this.projectData.CompanyId = rowData.companyId;
      this.projectData.ProcessType = "Reset";
      this.areYouSureModalType = "ResetCompanyCache";
      this.areYouSureModalRequestParameter = rowData.companyId;
      this.areYouSureModalWarningMessage = this.$t(
        "Components.AreYouSureModal.CompanyResetCacheWarning",
        {},
        { locale: this.$store.state.activeLang }
      );
      this.isCompanyCache = true;
    },
    onCompanyClearCacheButtonClick(rowData) {
      this.projectData.CompanyId = rowData.companyId;
      this.projectData.ProcessType = "Clear";
      this.areYouSureModalType = "ClearCompanyCache";
      this.areYouSureModalRequestParameter = rowData.companyId;
      this.areYouSureModalWarningMessage = this.$t(
        "Components.AreYouSureModal.CompanyClearCacheWarning",
        {},
        { locale: this.$store.state.activeLang }
      );
      this.isCompanyCache = true;
    },
    onChangeActivePassive(selected) {
      if (selected.key == 1) {
        this.isActive = "true";
      } else if (selected.key == 2) {
        this.isActive = "false";
      } else {
        this.isActive = "";
      }
    },
    onSearch(buttonName) {
      var button = $(String.format(".{0}", buttonName)),
        firstSpan = button.find("span:first"),
        loadingBlock = button.find(".loading-block"),
        disabledButtons = $(this.disabledButtonClasses);

      disabledButtons.prop("disabled", true);
      firstSpan.hide();
      if (loadingBlock.length === 0) {
        firstSpan.after(this.submitButtonHtml);
        loadingBlock = button.find(".loading-block");
      } else {
        loadingBlock.show();
      }

      var searchUrl = "Lcdp-ArgesetList",
        requestParameters = [];

      if (!String.isNullOrWhiteSpace(this.isActive)) {
        requestParameters.push({
          key: "isActive",
          value: this.isActive,
        });
      }

      this.gridSettings.requestUrl = ""; //trigger watch parameter
      this.gridSettings.requestUrl = String.createGetUrl(
        searchUrl,
        requestParameters
      );
    },
    onSearchEnd() {
      var button = $(String.format(".{0}", "btn-history-filter-search")),
        firstSpan = button.find("span:first"),
        loadingBlock = button.find(".loading-block"),
        disabledButtons = $(this.disabledButtonClasses);
      firstSpan.show();
      loadingBlock.hide();
      disabledButtons.prop("disabled", false);
    },
    getProjects() {
      this.$prodGatewayAxios
        .post("/Lcdp-ArgesetList?page=1&size=1000&isActive=true")
        .then((response) => {
          this.projects = response.data.items;
        })
        .catch(function (error) {
          //TODO:Error
          // alert(error);
        });
    },
    onClear() {
      this.selectsReset = !this.selectsReset;
    },
  },
  mounted() {
    this.getProjects();
  },
};
</script>
